import {useQuery, useQueryClient} from "react-query";
import axios from "axios";
import {useSnackbar} from "notistack";
import {DailyReportTotals} from "../types/DailyReportTotalizers.types";
import {resolveDailyReportDateTime, toDailyReportDayKey} from "../utils/DailyReportDateTime";

const API_URL = "api/daily-report/totalizers";

const fetchTotalizers = async (
    dateTime: string | null,
    powerStationIds?: number[] | null
): Promise<DailyReportTotals> => {
    const resolvedDateTime = resolveDailyReportDateTime(dateTime);
    if (!resolvedDateTime) {
        throw new Error("Data não selecionada");
    }

    try {
        const params = new URLSearchParams();
        params.append("dateTime", resolvedDateTime);
        if (powerStationIds && powerStationIds.length > 0) {
            powerStationIds.forEach((id) => params.append("powerStationIds", String(id)));
        }

        const response = await axios.get<DailyReportTotals>(API_URL, {
            params,
            timeout: 30000,
        });

        return response.data;
    } catch (error) {
        console.error("Erro ao buscar totalizadores do acompanhamento diário:", error);
        return Promise.reject(error);
    }
};

export const useDailyReportTotalizersQuery = (
    dateTime: string | null,
    powerStationIds?: number[] | null
) => {
    const {enqueueSnackbar} = useSnackbar();
    const queryClient = useQueryClient();
    const queryKey = ["daily-report-totalizers", toDailyReportDayKey(dateTime), powerStationIds];

    return useQuery({
        queryKey,
        queryFn: () => fetchTotalizers(dateTime, powerStationIds),
        enabled: !!dateTime,
        onError: (error: any) => {
            // Falha do refresh automático com dados já em tela: mantém o último valor sem repetir o aviso a cada ciclo.
            if (queryClient.getQueryData(queryKey) !== undefined) return;
            const errorMessage =
                error?.response?.data?.message ||
                error?.response?.data?.detail ||
                error?.message ||
                "Erro ao carregar totalizadores do acompanhamento diário";
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 3000,
            });
        },
    });
};
